// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-form-field {
  display: inline !important;
  position: relative;
  text-align: left;
  width: 100% !important;
}

.addcontact {
  height: 28px;
  line-height: 0;
  font-size: 12px;
  font-weight: 600;
  background-color: #17a0b4;
  border-radius: 5px;
  outline: none !important;
  border: none;
  cursor: pointer;
}

.removecontact {
  background: transparent;
  line-height: 4;
  border: transparent;
  cursor: pointer;
}

.spinner {
  position: absolute;
  right: 0%;
  bottom: 32%;
}

.btnsize {
  width: 27px;
  height: 27px;
  padding: 0px;
}

::ng-deep.requestform .mat-form-field-label {
  color: rgba(0, 0, 0, 0.7) !important;
}

::ng-deep.requestformImport .mat-form-field-label {
  color: rgba(0, 0, 0, 0.7) !important;
}

.cancelbtn {
  margin-top: -6px;
  margin-left: -11px;
}

.formwidth {
  max-width: 94%;
}

::ng-deep.main_page_paginator .mat-mdc-paginator-container {
  min-height: 40px !important;
  max-height: 40px !important;
}

::ng-deep.connField .mat-form-field-wrapper {
  padding-bottom: 0.5% !important;
}

::ng-deep.facField .mat-form-field-wrapper {
  padding-bottom: 1% !important;
}

.nav-tabs .nav-link.active, .nav-link.active:hover, .nav-link:hover {
  border-color: rgba(255, 255, 255, 0.13);
  border-bottom-color: #17a0b4;
  border-bottom-width: initial;
}

::ng-deep.mat-step-header .mat-step-icon-selected {
  background-color: #17a0b4;
  color: #fff;
}

::ng-deep.mat-step-header .mat-step-label-selected {
  font-weight: 600;
}

::ng-deep.mat-horizontal-stepper-header-container {
  background-color: #f1f1f1;
}

.next {
  background-color: #17a0b4 !important;
  font-size: 13px !important;
  color: white !important;
  height: 40px !important;
  cursor: pointer;
  width: 10%;
  justify-content: center;
  border-radius: 20px;
  font-weight: 600;
  outline: 0 !important;
}

.viewTabButtons {
  background-color: #17a0b4 !important;
  font-size: 13px !important;
  color: white !important;
  height: 33px !important;
  cursor: pointer;
  width: 100%;
  justify-content: center;
  border-radius: 20px;
  font-weight: 600;
  outline: 0 !important;
}

::ng-deep.requestform_project .mat-step-header {
  overflow: hidden;
  outline: 0;
  cursor: pointer;
  position: relative;
  box-sizing: content-box;
  -webkit-tap-highlight-color: transparent;
  height: 37px !important;
}

::ng-deep.requestform_project .mat-horizontal-content-container {
  overflow: hidden;
  padding: 20px !important;
}

.tab_content_container {
  height: 48lvh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-inline: 18px;
}

.fileNameStrike {
  text-decoration: line-through;
}

.fileNameBlack {
  color: black;
}

::ng-deep.tomatchip .mat-standard-chip.mat-chip-with-trailing-icon {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 5px;
  padding-left: 8px;
}

::ng-deep.tomatchip .mat-chip {
  font-size: 13px !important;
}

.subject {
  width: 100%;
  border-top-color: transparent;
  border-left-color: transparent;
  border-right-color: transparent;
  background-color: whitesmoke;
  border-bottom-width: thin;
  padding: 5px;
  font-weight: bold;
}

.editor {
  border: 2px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
.editor .NgxEditor__MenuBar {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
.editor .NgxEditor {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border: none;
}
.editor .CodeMirror {
  border: 1px solid #eee;
  height: auto;
  margin-bottom: 0.7rem;
}
.editor .CodeMirror pre {
  white-space: pre !important;
}

.importpatient .mat-expansion-panel-body {
  box-sizing: border-box !important;
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 15px;
  border-top: none;
}

.mat-content {
  display: flex !important;
  flex: 1;
  flex-direction: row;
  overflow: hidden;
}

.import_list .mat-expansion-panel-body {
  background-color: #ede8e8;
}

.textEllipsis {
  text-overflow: ellipsis;
  overflow-x: hidden;
  white-space: nowrap;
}

.customchip {
  font-size: 12px;
  min-height: 24px !important;
}

::ng-deep.mat-chip-list {
  display: inline-block;
}

.examplechiplist mat-form-field.mat-form-field.mat-form-field-appearance-fill > div.mat-form-field-wrapper > div.mat-form-field-flex > div.mat-form-field-infix {
  padding-inline: 5px;
  padding-block: 1px;
  padding-top: 0px !important;
  min-height: 40px !important;
}

.examplechiplist mat-form-field.mat-form-field.mat-form-field-appearance-fill > div.mat-form-field-wrapper > div.mat-form-field-flex > div.mat-form-field-infix > mat-chip-list.mat-chip-list {
  display: inline-block;
}

.examplechiplist .mat-form-field-appearance-fill.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {
  transform: translateY(-1.1em) scale(0.75);
  width: 133.33333%;
}

.mat-form-field-appearance-fill .mat-form-field-flex {
  border-radius: 4px 4px 0 0;
  padding: 0em 0.75em 0 0.75em !important;
}

.customoption {
  font-size: 13px !important;
  height: 32px !important;
}

.NgxEditor__Wrapper .angular-editor .angular-editor-wrapper .angular-editor-textarea {
  background-color: transparent !important;
  border: 1px solid #ddd !important;
  min-height: 180px !important;
  max-height: 180px !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  padding: 0.5rem 0.8rem 1rem !important;
  position: relative !important;
}

.downloadattach {
  background-color: #17a0b4 !important;
  color: #fff !important;
  border-radius: 20px;
  padding-bottom: 2px;
  padding-inline: 7px;
  font-size: 12px;
  padding-top: 3px;
  cursor: pointer;
}

.link_highlight {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
}

.link_highlight:hover {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
  background-color: #3fa4fb;
  padding-inline: 3%;
  padding-block: 2px;
  border-radius: 12px;
  color: white !important;
  cursor: pointer;
}

.project_label_title {
  position: absolute;
  padding-inline: 5px;
  font-size: 10px;
  top: -10px;
}

::ng-deep.saveVendormodal .modal-dialog {
  max-width: 90% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

ng-deep.saveVendormodal {
  top: 4% !important;
}

.edit_btn {
  padding-inline: 8px;
}

.font_ellipsis_project {
  font-size: 13px;
  text-overflow: ellipsis;
  display: block;
  overflow: hidden;
  white-space: nowrap;
}

#downloads {
  margin-top: 100% !important;
}

.container {
  justify-content: space-between;
  flex-direction: column;
  height: 100vh;
  display: flex;
}

.container .btn-holder {
  justify-content: flex-end;
  display: flex;
}

::ng-deep.mappingnote .modal-dialog {
  max-width: 83% !important;
  top: 10% !important;
  max-height: 60% !important;
  height: 52% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.myCustomModalClassFTP .modal-dialog {
  max-width: 98%;
  max-height: 80%;
  height: 80%;
}

::ng-deep.mat-mdc-form-field-icon-prefix .mat-icon {
  font-size: 20px !important;
  line-height: 32px !important;
  padding-inline: 2px !important;
  padding: 12px;
  box-sizing: content-box;
}

::ng-deep.mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}

::ng-deep.exoutlinestyles .mdc-notched-outline__notch label {
  transform: var(--mat-mdc-form-field-label-transform, translateY(-60%)) translateX(calc(1 * (17px + var(--mat-mdc-form-field-label-offset-x, 0px)))) !important;
}

::ng-deep.exoutlinestyles .mdc-notched-outline__leading {
  width: 25px !important;
}

.di-icon {
  font-size: 12px !important;
  line-height: 20px; /* This should match the font-size for perfect centering */
  vertical-align: middle;
  padding-left: 5px;
}

.diVB-icon {
  font-size: 14px !important;
  line-height: 20px;
  vertical-align: middle;
  padding-left: 5px;
}

.di-text {
  display: inline-block;
  vertical-align: middle;
  line-height: 21px; /* Same as .di-icon */
  text-align: center;
  margin-left: -1px;
}

::ng-deep.importpatient .mat-expansion-panel-content .mat-expansion-panel-body {
  height: 160px !important;
  overflow-x: hidden;
}

::ng-deep.reqformcustomtab .mat-mdc-tab-body-wrapper {
  height: 73vh !important;
  display: block !important;
  overflow: auto !important;
}
::ng-deep.reqformcustomtab .mat-mdc-tab-body-wrapper .mat-mdc-tab-body-content {
  overflow-y: auto;
  overflow-x: hidden;
}

.DIrecreate_btn {
  line-height: 20px;
  font-size: 12px !important;
  color: red !important;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.button-container {
  display: flex;
  align-items: center;
  gap: 5px;
  float: right;
}

::ng-deep .tab-group-wrapper {
  position: relative;
}

::ng-deep .create-new-tab-btn {
  position: absolute;
  top: 5px;
  right: 15px;
  height: 100%;
  display: flex;
  align-items: center;
  z-index: 10;
  cursor: pointer;
}

.bottom-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f8f9fa;
  border-top: 1px solid #dee2e6;
  padding: 8px 15px;
  height: 40px;
  z-index: 1000;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.timezone-notice-left {
  flex: 1;
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;
}
.timezone-notice-left .timezone-notice-content {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #6c757d;
  font-style: italic;
  width: 100%;
  overflow: hidden;
}
.timezone-notice-left .timezone-notice-content i {
  margin-right: 8px;
  color: #17a2b8;
  font-size: 14px;
  flex-shrink: 0;
}
.timezone-notice-left .timezone-notice-content span {
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pagination-right {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/CIIS/request-form/request-form.component.scss"],"names":[],"mappings":"AAAA;EACI,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AACJ;;AAEE;EACE,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,wBAAA;EACA,YAAA;EACA,eAAA;AACJ;;AACE;EAEE,uBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;AACJ;;AACE;EAEE,kBAAA;EACD,SAAA;EACC,WAAA;AACJ;;AACE;EACE,WAAA;EACA,YAAA;EACA,YAAA;AAEJ;;AAAE;EACE,oCAAA;AAGJ;;AAAE;EACE,oCAAA;AAGJ;;AADE;EAEA,gBAAA;EACA,kBAAA;AAGF;;AADA;EAEE,cAAA;AAGF;;AAAE;EACE,2BAAA;EACA,2BAAA;AAGJ;;AAAA;EACE,+BAAA;AAGF;;AAAA;EACE,6BAAA;AAGF;;AAAA;EACE,uCAAA;EACA,4BAAA;EACA,4BAAA;AAGF;;AACA;EACI,yBAAA;EACA,WAAA;AAEJ;;AAAA;EACE,gBAAA;AAGF;;AAAA;EACE,yBAAA;AAGF;;AAAA;EACI,oCAAA;EACA,0BAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AAGJ;;AAAE;EACI,oCAAA;EACA,0BAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AAGN;;AAAA;EACE,gBAAA;EACE,UAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,wCAAA;EACA,uBAAA;AAGJ;;AAAA;EACE,gBAAA;EACA,wBAAA;AAGF;;AACA;EACE,aAAA;EAAc,gBAAA;EAAiB,kBAAA;EAAmB,oBAAA;AAKpD;;AAFA;EACA,6BAAA;AAKA;;AAFA;EACE,YAAA;AAKF;;AAFA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AAKF;;AAFA;EACE,0BAAA;AAKF;;AAHA;EACE,WAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,4BAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;AAMF;;AAFA;EACE,oCAAA;EACA,kBAAA;AAKF;AAHE;EACE,2BAAA;EACA,4BAAA;EACA,2CAAA;AAKJ;AAFE;EACE,yBAAA;EACA,0BAAA;EACA,YAAA;AAIJ;AADE;EACE,sBAAA;EACA,YAAA;EACA,qBAAA;AAGJ;AADI;EACE,2BAAA;AAGN;;AAEA;EACI,iCAAA;AACJ;;AAEE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;AACJ;;AAEE;EACE,wBAAA;EACA,OAAA;EACA,mBAAA;EACA,gBAAA;AACJ;;AAIA;EACE,yBAAA;AADF;;AAMA;EACI,uBAAA;EACA,kBAAA;EACA,mBAAA;AAHJ;;AAKA;EAEI,eAAA;EACA,2BAAA;AAHJ;;AAMI;EACE,qBAAA;AAHN;;AAMI;EACE,mBAAA;EACE,kBAAA;EACA,2BAAA;EACA,2BAAA;AAHR;;AAII;EAEG,qBAAA;AAFP;;AAKI;EACI,yCAAA;EACA,iBAAA;AAFR;;AAII;EACE,0BAAA;EACA,uCAAA;AADN;;AAGI;EACE,0BAAA;EACF,uBAAA;AAAJ;;AAGA;EACE,wCAAA;EACA,iCAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,sCAAA;EACA,6BAAA;AAAF;;AAGA;EAEE,oCAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AADF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;AAAF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AACF;;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;AAAF;;AAGA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAAF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACE,eAAA;EAAgB,uBAAA;EAAwB,cAAA;EAAe,gBAAA;EAAiB,mBAAA;AAK1E;;AAHA;EACI,2BAAA;AAMJ;;AAHA;EACE,8BAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;AAMF;;AAJA;EACE,yBAAA;EACA,aAAA;AAOF;;AAJA;EACE,yBAAA;EACA,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAOF;;AAHA;EACE,cAAA;EACA,eAAA;EACA,WAAA;AAMF;;AAJA;EACE,0BAAA;EACA,4BAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;AAOF;;AALA;EACE,wBAAA;AAQF;;AALA;EACE,8JAAA;AAQF;;AANA;EACE,sBAAA;AASF;;AANA;EACE,0BAAA;EACA,iBAAA,EAAA,0DAAA;EACA,sBAAA;EACA,iBAAA;AASF;;AANA;EACE,0BAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AASF;;AANA;EACE,qBAAA;EACA,sBAAA;EACA,iBAAA,EAAA,qBAAA;EACA,kBAAA;EACA,iBAAA;AASF;;AAJI;EACE,wBAAA;EACA,kBAAA;AAON;;AAHA;EACE,uBAAA;EACA,yBAAA;EACA,yBAAA;AAMF;AAJE;EACE,gBAAA;EACA,kBAAA;AAMJ;;AAFA;EACC,iBAAA;EACC,0BAAA;EACA,qBAAA;EACA,YAAA;EACF,aAAA;EACE,mBAAA;EACA,uBAAA;AAKF;;AADA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAIF;;AAAA;EACE,kBAAA;AAGF;;AAAA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EAEA,eAAA;AAEF;;AACA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,6BAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;AAEF;;AAEA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AACJ;AACI;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AACN;AAEI;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAAN;;AAMA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AAHF","sourcesContent":[".mat-form-field{\r\n    display: inline !important;\r\n    position: relative;\r\n    text-align: left;\r\n    width: 100% !important;\r\n  }\r\n\r\n  .addcontact {\r\n    height: 28px;\r\n    line-height: 0;\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    background-color: #17a0b4;\r\n    border-radius: 5px;\r\n    outline: none !important;\r\n    border: none;\r\n    cursor: pointer;\r\n  }\r\n  .removecontact\r\n  {\r\n    background: transparent;\r\n    line-height: 4;\r\n    border: transparent;\r\n    cursor: pointer;\r\n  }\r\n  .spinner\r\n  {\r\n    position: absolute;\r\n   right:0%;\r\n    bottom: 32%;\r\n  }\r\n  .btnsize{\r\n    width: 27px;\r\n    height: 27px;\r\n    padding: 0px;\r\n}\r\n  ::ng-deep.requestform .mat-form-field-label {\r\n    color: rgb(0 0 0 / 70%) !important;\r\n  }\r\n\r\n  ::ng-deep.requestformImport .mat-form-field-label {\r\n    color: rgb(0 0 0 / 70%) !important;\r\n  }\r\n  .cancelbtn\r\n{\r\n  margin-top: -6px;\r\n  margin-left: -11px;\r\n}\r\n.formwidth\r\n{\r\n  max-width: 94%;\r\n}\r\n::ng-deep.main_page_paginator{\r\n  .mat-mdc-paginator-container{\r\n    min-height: 40px !important;\r\n    max-height: 40px !important;\r\n  }\r\n}\r\n::ng-deep.connField .mat-form-field-wrapper{\r\n  padding-bottom: 0.5% !important;\r\n}\r\n\r\n::ng-deep.facField .mat-form-field-wrapper{\r\n  padding-bottom: 1% !important;\r\n}\r\n\r\n.nav-tabs .nav-link.active,.nav-link.active:hover,.nav-link:hover {\r\n  border-color: rgba(255, 255, 255, 0.13);\r\n  border-bottom-color: #17a0b4;\r\n  border-bottom-width: initial;\r\n}\r\n\r\n\r\n::ng-deep.mat-step-header .mat-step-icon-selected  {\r\n    background-color: #17a0b4;\r\n    color: #fff;\r\n}\r\n::ng-deep.mat-step-header .mat-step-label-selected{\r\n  font-weight: 600;\r\n}\r\n\r\n::ng-deep.mat-horizontal-stepper-header-container{\r\n  background-color: #f1f1f1;\r\n}\r\n\r\n.next{\r\n    background-color: #17a0b4 !important;\r\n    font-size: 13px !important;\r\n    color: white !important;\r\n    height: 40px !important;\r\n    cursor: pointer;\r\n    width: 10%;\r\n    justify-content: center;\r\n    border-radius: 20px;\r\n    font-weight: 600;\r\n    outline: 0 !important;\r\n}\r\n\r\n  .viewTabButtons {\r\n      background-color: #17a0b4 !important;\r\n      font-size: 13px !important;\r\n      color: white !important;\r\n      height: 33px !important;\r\n      cursor: pointer;\r\n      width: 100%;\r\n      justify-content: center;\r\n      border-radius: 20px;\r\n      font-weight: 600;\r\n      outline: 0 !important;\r\n  }\r\n\r\n::ng-deep.requestform_project .mat-step-header{\r\n  overflow: hidden;\r\n    outline: 0;\r\n    cursor: pointer;\r\n    position: relative;\r\n    box-sizing: content-box;\r\n    -webkit-tap-highlight-color: transparent;\r\n    height: 37px !important;\r\n\r\n}\r\n::ng-deep.requestform_project .mat-horizontal-content-container {\r\n  overflow: hidden;\r\n  padding: 20px !important;\r\n}\r\n\r\n\r\n.tab_content_container{\r\n  height: 48lvh;overflow-y: auto;overflow-x: hidden;padding-inline: 18px;\r\n }\r\n\r\n.fileNameStrike{\r\ntext-decoration: line-through;\r\n}\r\n\r\n.fileNameBlack{\r\n  color: black;\r\n}\r\n\r\n::ng-deep.tomatchip .mat-standard-chip.mat-chip-with-trailing-icon {\r\n  padding-top: 5px;\r\n  padding-bottom: 5px;\r\n  padding-right: 5px;\r\n  padding-left: 8px;\r\n}\r\n\r\n::ng-deep.tomatchip .mat-chip {\r\n  font-size: 13px !important;\r\n}\r\n.subject{\r\n  width: 100%;\r\n  border-top-color: transparent;\r\n  border-left-color: transparent;\r\n  border-right-color: transparent;\r\n  background-color: whitesmoke;\r\n  border-bottom-width: thin;\r\n  padding: 5px;\r\n  font-weight: bold;\r\n}\r\n\r\n\r\n.editor {\r\n  border: 2px solid rgba(0, 0, 0, 0.2);\r\n  border-radius: 4px;\r\n\r\n  .NgxEditor__MenuBar {\r\n    border-top-left-radius: 4px;\r\n    border-top-right-radius: 4px;\r\n    border-bottom: 1px solid rgba(0, 0, 0, 0.2);\r\n  }\r\n\r\n  .NgxEditor {\r\n    border-top-left-radius: 0;\r\n    border-top-right-radius: 0;\r\n    border: none;\r\n  }\r\n\r\n  .CodeMirror {\r\n    border: 1px solid #eee;\r\n    height: auto;\r\n    margin-bottom: 0.7rem;\r\n\r\n    pre {\r\n      white-space: pre !important;\r\n    }\r\n  }\r\n}\r\n\r\n.importpatient .mat-expansion-panel-body{\r\n    box-sizing: border-box !important;\r\n  }\r\n\r\n  .modal-footer {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n    padding: 15px;\r\n    border-top: none;\r\n  }\r\n\r\n  .mat-content {\r\n    display: flex !important;\r\n    flex: 1;\r\n    flex-direction: row;\r\n    overflow: hidden;\r\n}\r\n\r\n\r\n\r\n.import_list .mat-expansion-panel-body{\r\n  background-color: #ede8e8;\r\n\r\n}\r\n\r\n\r\n.textEllipsis{\r\n    text-overflow: ellipsis;\r\n    overflow-x: hidden;\r\n    white-space: nowrap;\r\n}\r\n.customchip\r\n  {\r\n    font-size: 12px;\r\n    min-height: 24px !important;\r\n  }\r\n\r\n    ::ng-deep.mat-chip-list{\r\n      display:inline-block ;\r\n    }\r\n\r\n    .examplechiplist mat-form-field.mat-form-field.mat-form-field-appearance-fill > div.mat-form-field-wrapper > div.mat-form-field-flex > div.mat-form-field-infix  {\r\n      padding-inline: 5px ;\r\n        padding-block: 1px ;\r\n        padding-top: 0px !important;\r\n        min-height: 40px !important ; }\r\n    .examplechiplist mat-form-field.mat-form-field.mat-form-field-appearance-fill > div.mat-form-field-wrapper > div.mat-form-field-flex > div.mat-form-field-infix > mat-chip-list.mat-chip-list\r\n    {\r\n       display: inline-block;\r\n      }\r\n\r\n    .examplechiplist .mat-form-field-appearance-fill.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {\r\n        transform: translateY(-1.1em) scale(.75);\r\n        width: 133.33333%;\r\n    }\r\n    .mat-form-field-appearance-fill .mat-form-field-flex {\r\n      border-radius: 4px 4px 0 0;\r\n      padding: 0em 0.75em 0 0.75em !important;\r\n    }\r\n    .customoption{\r\n      font-size: 13px !important;\r\n    height: 32px !important;\r\n}\r\n\r\n.NgxEditor__Wrapper .angular-editor .angular-editor-wrapper .angular-editor-textarea{\r\n  background-color: transparent !important;\r\n  border: 1px solid #ddd !important;\r\n  min-height: 180px !important;\r\n  max-height: 180px !important;\r\n  overflow-x: hidden !important;\r\n  overflow-y: auto !important;\r\n  padding: 0.5rem 0.8rem 1rem !important;\r\n  position: relative !important;\r\n}\r\n\r\n.downloadattach\r\n{\r\n  background-color: #17a0b4 !important;\r\n  color: #fff !important;\r\n  border-radius: 20px;\r\n  padding-bottom: 2px;\r\n  padding-inline: 7px;\r\n  font-size: 12px;\r\n  padding-top: 3px;\r\n  cursor: pointer;\r\n}\r\n.link_highlight{\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 90% !important;\r\n  display: inline-block;\r\n}\r\n.link_highlight:hover{\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 90% !important;\r\n  display: inline-block;\r\n  background-color: #3fa4fb;\r\n  padding-inline: 3%;\r\n  padding-block: 2px;\r\n  border-radius: 12px;\r\n  color: white !important;\r\n  cursor: pointer;\r\n\r\n}\r\n\r\n.project_label_title{\r\n  position: absolute;\r\n  padding-inline: 5px;\r\n  font-size: 10px;\r\n  top: -10px;\r\n}\r\n\r\n::ng-deep.saveVendormodal .modal-dialog {\r\n  max-width: 90%!important;\r\n  max-height: 60%!important;\r\n  height: 60%!important;\r\n  margin: auto!important;\r\n  padding: 0 !important;\r\n}\r\nng-deep.saveVendormodal{\r\n  top: 4%!important;\r\n}\r\n\r\n.edit_btn{\r\n    padding-inline: 8px;\r\n}\r\n\r\n.font_ellipsis_project{\r\n  font-size: 13px;text-overflow: ellipsis;display: block;overflow: hidden;white-space: nowrap;\r\n}\r\n#downloads{\r\n    margin-top: 100% !important ;\r\n}\r\n\r\n.container {\r\n  justify-content: space-between;\r\n  flex-direction: column;\r\n  height: 100vh;\r\n  display: flex;\r\n}\r\n.container .btn-holder {\r\n  justify-content: flex-end;\r\n  display: flex;\r\n}\r\n\r\n::ng-deep.mappingnote .modal-dialog{\r\n  max-width: 83% !important;\r\n  top: 10%!important;\r\n  max-height: 60% !important;\r\n  height: 52% !important;\r\n  margin: auto !important;\r\n  padding: 0 !important;\r\n}\r\n\r\n\r\n::ng-deep.myCustomModalClassFTP .modal-dialog {\r\n  max-width: 98%;\r\n  max-height: 80%;\r\n  height: 80%;\r\n}\r\n::ng-deep.mat-mdc-form-field-icon-prefix .mat-icon {\r\n  font-size: 20px !important;\r\n  line-height: 32px   !important;\r\n  padding-inline: 2px !important;\r\n  padding: 12px;\r\n  box-sizing: content-box;\r\n}\r\n::ng-deep.mat-mdc-form-field-subscript-wrapper{\r\n  display: none !important;\r\n}\r\n\r\n::ng-deep.exoutlinestyles .mdc-notched-outline__notch label{\r\n  transform: var(--mat-mdc-form-field-label-transform, translateY(-60%)) translateX(calc(1 * (17px + var(--mat-mdc-form-field-label-offset-x, 0px)))) !important;\r\n}\r\n::ng-deep.exoutlinestyles .mdc-notched-outline__leading{\r\n  width: 25px !important;\r\n}\r\n\r\n.di-icon {\r\n  font-size: 12px !important;\r\n  line-height: 20px; /* This should match the font-size for perfect centering */\r\n  vertical-align: middle;\r\n  padding-left: 5px;\r\n}\r\n\r\n.diVB-icon {\r\n  font-size: 14px !important;\r\n  line-height: 20px; \r\n  vertical-align: middle;\r\n  padding-left: 5px;\r\n}\r\n\r\n.di-text {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  line-height: 21px; /* Same as .di-icon */\r\n  text-align: center;\r\n  margin-left: -1px;\r\n}\r\n\r\n::ng-deep.importpatient{\r\n  .mat-expansion-panel-content{\r\n    .mat-expansion-panel-body{\r\n      height: 160px !important;\r\n      overflow-x: hidden;\r\n    }\r\n    }\r\n}\r\n::ng-deep.reqformcustomtab .mat-mdc-tab-body-wrapper{\r\n  height:73vh !important;\r\n  display: block !important;\r\n  overflow: auto !important;\r\n  \r\n  .mat-mdc-tab-body-content {\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n  }\r\n}\r\n\r\n.DIrecreate_btn {\r\n line-height: 20px;\r\n  font-size: 12px !important;\r\n  color: red !important;\r\n  height: 18px ;\r\ndisplay: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n \r\n}\r\n\r\n.button-container {\r\n  display: flex; \r\n  align-items: center; \r\n  gap: 5px; \r\n  float: right;\r\n \r\n}\r\n\r\n::ng-deep .tab-group-wrapper {\r\n  position: relative;\r\n}\r\n\r\n::ng-deep .create-new-tab-btn {\r\n  position: absolute;\r\n  top: 5px;\r\n  right: 15px;\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  z-index: 10;\r\n \r\n  cursor: pointer;\r\n}\r\n\r\n.bottom-section {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background-color: #f8f9fa;\r\n  border-top: 1px solid #dee2e6;\r\n  padding: 8px 15px;\r\n  height: 40px;\r\n  z-index: 1000;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  overflow: hidden;\r\n}\r\n\r\n// Timezone Notice (Left side)\r\n.timezone-notice-left {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  min-width: 0; // Allows flex item to shrink below content size\r\n  overflow: hidden;\r\n  \r\n  .timezone-notice-content {\r\n    display: flex;\r\n    align-items: center;\r\n    font-size: 12px;\r\n    color: #6c757d;\r\n    font-style: italic;\r\n    width: 100%;\r\n    overflow: hidden;\r\n    \r\n    i {\r\n      margin-right: 8px;\r\n      color: #17a2b8;\r\n      font-size: 14px;\r\n      flex-shrink: 0; // Prevents icon from shrinking\r\n    }\r\n    \r\n    span {\r\n      font-weight: 500;\r\n      white-space: nowrap;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n    }\r\n  }\r\n}\r\n\r\n// Pagination (Right side)\r\n.pagination-right {\r\n  flex: 0 0 auto;\r\n  display: flex;\r\n  align-items: center;\r\n  overflow: hidden;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
